import React from "react";
import { useNavigate } from "react-router-dom";

const PasswordSuccess: React.FC = () => {
  const navigate = useNavigate();
  const handleRedirect = () => {
    console.log("Redirecting to login...");
    navigate("/login");
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
      {/* Logo and Name */}
      <div className="absolute top-6 left-8 flex items-center space-x-2">
        <img
          src="/images/RAJAPI_logo.png"
          alt="Rajapi Logo"
          className="w-8 h-8"
        />
        <span className="text-xl font-extrabold text-blue-500">RAJAPI-COP</span>
      </div>

      {/* Card */}
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-sm w-full text-center">
        <div className="text-blue-500 text-4xl mb-4 text-center">
          <img src="/images/Icon_end.png" className="ml-[35%]" />
        </div>
        <h2 className="text-lg font-semibold">
          Votre mot de passe a été changé avec succès
        </h2>
        <p className="text-sm text-gray-600 mt-2">
          Assurez-vous de vous souvenir de votre nouveau mot de passe.
        </p>

        <button
          type="button"
          onClick={handleRedirect}
          className="w-full mt-6 bg-blue-500 hover:bg-blue-600 text-white py-2 rounded-lg"
        >
          Revenir à la connexion
        </button>
      </div>

      <footer className="absolute bottom-4 text-gray-400 text-sm">
        © 2024 Kiosk
      </footer>
    </div>
  );
};

export default PasswordSuccess;
